/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CAMBODIA_TRANSPORT_HOME_OR_A_PLACE_TO_SLEEP_FOR_WORKERS_WHO_FIN',
              'CAMBODIA_WAGE_SUPPLEMENTS_INCLUDING_TRANSPORTATION_AND_HOUSING_',
              'CAMBODIA_ATTENDANCE_BONUS_DURING_LEAVE',
              'CAMBODIA_ATTENDANCE_BONUS_TO_NEW_WORKERS',
              'CAMBODIA_ATTENDANCE_BONUS_TO_CASUAL_WORKERS',
              'CAMBODIA_SENIORITY_INDEMNITY_FOR_UNDETERMINED_DURATION_CONTRACT',
              'HAVE_THERE_BEEN_ANY_CASES_OF_HARASSMENT_BASED_UPON_RACE_ETHNIC_',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    cambodia_which_of_the_following_other_wage_payments_were_not_in: valueSchema,
  },
}
